import { LaunchType } from './launch';

export type PageProps = any;
export type TrackProps = any;
export type IdentifyProps = any;

export enum AuthType {
  EMAIL = 'email',
  PHONE = 'phone',
}

export const AuthMethod = {
  [AuthType.EMAIL]: 'email',
  [AuthType.PHONE]: 'sms',
};

export enum ErrorType {
  MODAL = 'modal',
  INLINE = 'inline',
  FULLSCREEN = 'fullScreen',
}

export interface InteractTrackingProps {
  action?: string;
  view?: string;
  viewTypeId?: string;
  id?: string;
  element?: string;
  component?: string;
  index?: number;
}

export interface ErrorMessageDisplayedTrackingProps {
  message: string;
  errorType: ErrorType;
  component: string;
  view?: string;
  viewTypeId?: string;
  canRetry: boolean;
  code?: number;
}
export interface EventId {
  event_id: string;
}

export interface PixelEvent {
  event: string;
  properties?: Record<string, unknown>;
  eventId?: EventId;
}

export enum SubscribeAndAuthViews {
  ACTIVATE = 'activate',
  AUTHENTICATE = 'authenticate',
  AUTHORIZE = 'authorize',
  DEFAULT = 'subscribe',
  SIGNUP = 'signup',
}
export type InteractViewTypes = SubscribeAndAuthViews | LaunchType;

export type InteractTrackingHandlerProps = InteractTrackingProps & {
  element: string;
};

export type InteractTrackHandler = (propOverrides: InteractTrackingHandlerProps) => void;
